<div class="dashboard-heading border-0"></div>

@if (problem) {
  <form action="your-action" (submit)="onFormSubmit($event)" class="table-align-center mb-4">
    <div>
      <div>{{ 'CODE' | translate }}</div>
      <div>{{ problem?.id }}</div>
    </div>
    <div>
      <div>{{ 'ACTIVE' | translate }}</div>
      <div>
        <div class="d-flex align-items-center">
          <dx-check-box [(value)]="problem.isActive" class="me-2"></dx-check-box>
          @if (!isCreateMode && !problem?.isActive) {
            <div>{{ 'DECIDED' | translate }}</div>
          }
        </div>
      </div>
    </div>
    <div>
      <div>{{ 'DATE_PUBLICATION' | translate }}</div>
      <div>
        <dx-date-box [(value)]="problem.publishDate" type="datetime" displayFormat="dd-MM-yyyy HH:mm">
          <dx-validator>
            <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
            <dxi-validation-rule
              type="compare"
              [comparisonTarget]="fixDateComparison"
              comparisonType="<"
              message="{{ 'FIELD_INCORECT_PUBLISH_DATE' | translate }}"></dxi-validation-rule>
          </dx-validator>
        </dx-date-box>
      </div>
    </div>
    <div>
      <div>{{ 'PLANED_DATE_FIX' | translate }}</div>
      <div>
        <dx-date-box [(value)]="problem.fixDate" type="datetime" displayFormat="dd-MM-yyyy HH:mm">
          <dx-validator>
            <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
            <dxi-validation-rule
              type="compare"
              [comparisonTarget]="publishDateComparison"
              comparisonType=">"
              message="{{ 'FIELD_INCORECT_FIX_DATE' | translate }}"></dxi-validation-rule>
          </dx-validator>
        </dx-date-box>
      </div>
    </div>
    <div>
      <div>{{ 'TIME_ELIMINATION' | translate }}</div>
      <div>{{ getTimeLeft() }}</div>
    </div>
    <div>
      <div>{{ 'TITLE' | translate }}</div>
      <div>
        <dx-text-box [(value)]="problem.title" valueChangeEvent="keyup">
          <dx-validator>
            <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
    </div>
    <div>
      <div>{{ 'DESCRIPTION' | translate }}</div>
      <div>
        <dx-text-area [height]="150" [maxLength]="2500" [(value)]="problem.description" valueChangeEvent="keyup">
          <dx-validator>
            <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
          </dx-validator>
        </dx-text-area>
      </div>
    </div>
    <div>
      <div></div>
      <div>
        <div class="file-upload text-center">
          <dx-file-uploader
            [uploadUrl]="uploadUrl"
            [multiple]="false"
            [disabled]="!problem.id"
            [showFileList]="false"
            selectButtonText="{{ 'SELECT_FILE' | translate }}"
            labelText=""
            uploadMode="instantly"
            uploadMethod="PUT"
            (onValueChanged)="onValueChanged()"
            (onUploaded)="onUploaded($event)"
            [accept]="allowedFileExtensions"
            [maxFileSize]="3 * 1024 * 1024"
            [allowedFileExtensions]="allowedFileExtensions"></dx-file-uploader>
          @if (problem.image) {
            <img [src]="convertImage(problem)" class="problem-image" />
          }
        </div>
      </div>
    </div>
    <div>
      <div></div>
      <div>
        <dx-validation-summary></dx-validation-summary>
      </div>
    </div>
    <div>
      <div></div>
      <div>
        @if (!isCreateMode && problem?.isActive) {
          <dx-button
            text="{{ 'PROBLEM_SOLVED' | translate }}"
            [disabled]="isChanged()"
            (onClick)="problemSolved()"
            class="btn me-2"
            icon="mdi mdi-check"></dx-button>
        }
        <dx-button
          text="{{ 'SAVE' | translate }}"
          [useSubmitBehavior]="true"
          [disabled]="!isChanged()"
          class="btn me-2"
          icon="mdi mdi-content-save"></dx-button>
        <dx-button text="{{ 'CLOSE' | translate }}" (onClick)="close()" class="btn btn-light"></dx-button>
      </div>
    </div>
  </form>
}
